import React, { Fragment } from 'react';
import { css } from 'aphrodite/no-important';

import styles from './accessPointRow.styles';
import HealthIndicators from '../common/healthIndicators';
import NoDataFound from '../common/noDataFound';

export const AccessPointRow = props => {
  const { status } = props;
  if (status) {
    let deleteDiv = (<div
      className={css(styles.field, styles.notrash)}
    >
    </div>)
    if(!status.siteId){
      deleteDiv = (<div
        className={css(styles.field, styles.trash)}
        onClick={() => props.handleDeleteModalState(status)}
      >
        <span className="lnr lnr-trash" />
      </div>);
    } 
    return (
      <Fragment>
        <div className={css(styles.base)}>
          <div className={css(styles.field, styles.light)}>
            <HealthIndicators status={status} />
          </div>
          <div className={css(styles.field, styles.macAddress)} title={status && status.nodeAddress}>
            <span className={css(styles.name)}>
              {status && status.name}
            </span>
          </div>
          <div className={css(styles.field, styles.macAddress)}>
            <span className={css(styles.name)}>
              {status && status.nodeAddress}
            </span>
          </div>
          <div className={css(styles.field, styles.referencePointsCount)}>
            {status && status.referencePointsCount}
          </div>
          <div className={css(styles.field, styles.tagsCount)}>
            {status && status.tagsCount}
          </div>
          <div className={css(styles.field, styles.lastSeen)}>
            <span className={css(styles.name)}>
              {status && status.lastSeenAt}
            </span>
          </div>
          {deleteDiv}
        </div>
      </Fragment>
    );
  }
  return <NoDataFound />;
};



// WEBPACK FOOTER //
// ./src/components/data/status/accesspoint/accessPointRow.js